// ── Shared tokens (same in both modes) ──────────────
const shared = {
  fonts: {
    family: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
  },
  radius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
  },
  transitions: {
    default: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    fast: 'all 0.15s ease',
    slow: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
  },
};

// ── Dark Theme ──────────────────────────────────────
export const darkTheme = {
  ...shared,
  mode: 'dark',
  colors: {
    bg_primary: '#0b1121',
    bg_secondary: '#111827',
    bg_card: 'rgba(255, 255, 255, 0.03)',
    bg_card_hover: 'rgba(255, 255, 255, 0.06)',
    bg_navbar: 'rgba(11, 17, 33, 0.6)',
    glass_border: 'rgba(255, 255, 255, 0.08)',
    glass_border_hover: 'rgba(255, 255, 255, 0.15)',

    accent: '#3b82f6',
    accent_light: '#60a5fa',
    accent_dark: '#2563eb',
    accent_gradient: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    accent_gradient_hover: 'linear-gradient(135deg, #2563eb, #7c3aed)',

    white: '#f8fafc',
    heading: '#f1f5f9',
    para: '#94a3b8',
    muted: '#64748b',

    border: '#1e293b',
    border_light: '#334155',
    shadow: 'rgba(0, 0, 0, 0.3)',
    overlay: 'rgba(11, 17, 33, 0.95)',
  },
  shadows: {
    card: '0 4px 20px rgba(0, 0, 0, 0.25)',
    card_hover: '0 8px 40px rgba(59, 130, 246, 0.15)',
    button: '0 4px 15px rgba(59, 130, 246, 0.3)',
    navbar: '0 4px 30px rgba(0, 0, 0, 0.2)',
  },
};

// ── Light Theme ─────────────────────────────────────
export const lightTheme = {
  ...shared,
  mode: 'light',
  colors: {
    bg_primary: '#f8fafc',
    bg_secondary: '#f1f5f9',
    bg_card: 'rgba(255, 255, 255, 0.5)',
    bg_card_hover: 'rgba(255, 255, 255, 0.65)',
    bg_navbar: 'rgba(248, 250, 252, 0.6)',
    glass_border: 'rgba(255, 255, 255, 0.3)',
    glass_border_hover: 'rgba(59, 130, 246, 0.3)',

    accent: '#3b82f6',
    accent_light: '#2563eb',
    accent_dark: '#1d4ed8',
    accent_gradient: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    accent_gradient_hover: 'linear-gradient(135deg, #2563eb, #7c3aed)',

    white: '#ffffff',
    heading: '#0f172a',
    para: '#475569',
    muted: '#94a3b8',

    border: '#e2e8f0',
    border_light: '#cbd5e1',
    shadow: 'rgba(0, 0, 0, 0.08)',
    overlay: 'rgba(248, 250, 252, 0.95)',
  },
  shadows: {
    card: '0 4px 20px rgba(0, 0, 0, 0.06)',
    card_hover: '0 8px 40px rgba(59, 130, 246, 0.1)',
    button: '0 4px 15px rgba(59, 130, 246, 0.25)',
    navbar: '0 4px 30px rgba(0, 0, 0, 0.06)',
  },
};
